export default __webpack_public_path__ + "static/media/mode-533.c9cd3991.svg";